import React from 'react';

import defaultPhoto from '@assets/img/arts/default-photo.png';
import pdfIcon from '@assets/img/icons/pdf.svg';
import { RemoteFile } from '@models/next/FileType';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { isImageFileName, isPdfFileName } from '@utils/types';
import clsx from 'clsx';
import Color from 'color';

const useStyles = makeMuiStyles((theme, common) => ({
  fileDisplayContainer: {
    backgroundColor: 'white',
    position: 'relative',
  },
  fileDisplayDefaultPhotoContainer: {
    ...common.flexCenter,
    backgroundColor: theme.palette.grey[200],
    width: '100%',
    height: '100%',
  },
  fileDisplayPdfContainer: {
    ...common.flexColumnCenter,
    rowGap: '0.5rem',
    width: '100%',
    height: '100%',
  },
  fileDisplayImage: {
    objectFit: 'cover',
    objectPosition: 'center',
    width: '100%',
    height: '100%',
  },
  fileDisplayLabel: {
    ...common.flexCenter,
    ...common.smallerText,
    ...common.textGray800,
    position: 'absolute',
    right: '0px',
    bottom: '0px',
    left: '0px',
    height: '21px',
    backgroundColor: Color(theme.palette.grey[300]).alpha(0.85).toString(),
    pointerEvents: 'none',
  },
}));

export const FileDisplay: React.FC<{
  file?: RemoteFile | null;
  label?: React.ReactNode;
  className?: string;
  withPdfFileName?: boolean;
}> = ({ file, label, className, withPdfFileName }) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <div className={clsx(classes.fileDisplayContainer, className)}>
      {!file ? (
        <div className={classes.fileDisplayDefaultPhotoContainer}>
          <img src={defaultPhoto} alt="No Photo" style={{ width: 34, height: 28 }} />
        </div>
      ) : (
        <>
          {isPdfFileName(file.name) && (
            <div className={classes.fileDisplayPdfContainer}>
              <img src={pdfIcon} alt="PDF" style={{ width: 32, height: 32 }} />
              {withPdfFileName && (
                <label className={clsx(classes.textGray500, classes.middleText)}>
                  {file?.name}
                </label>
              )}
            </div>
          )}

          {isImageFileName(file.name) && (
            <img src={file.url} alt={file.name} className={classes.fileDisplayImage} />
          )}
        </>
      )}

      {label && <label className={classes.fileDisplayLabel}>{label}</label>}
    </div>
  );
};
